import angular from 'angular';
/**
 * @ngdoc module
 * @name flowingly.runner.library
 * @module flowingly.runner.library
 * @description This module is used to display the flow model library
 */
const m = angular.module('flowingly.runner.library', [
  'kendo.directives',
  'flowingly.directives',
  'flowingly.components'
]);

m.run([
  '$templateCache',
  function ($templateCache: angular.ITemplateCacheService) {
    $templateCache.put(
      'Client/runner.library/runner.library.flow.model.owner/runner.library.flow.model.owner.dialog.flow-model-tab.tmpl.html',
      require('./runner.library.flow.model.owner/runner.library.flow.model.owner.dialog.flow-model-tab.tmpl.html')
        .default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.flow.model.owner/runner.library.flow.model.owner.dialog.report-tab.tmpl.html',
      require('./runner.library.flow.model.owner/runner.library.flow.model.owner.dialog.report-tab.tmpl.html')
        .default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.flow.model.owner/runner.library.flow.model.owner.dialog.tmpl.html',
      require('./runner.library.flow.model.owner/runner.library.flow.model.owner.dialog.tmpl.html')
        .default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.header.tmpl.html',
      require('./runner.library.header.tmpl.html').default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.tmpl.html',
      require('./runner.library.tmpl.html').default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.flow.model.owner/runner.library.public.sharing.config.tmpl.html',
      require('./runner.library.flow.model.owner/runner.library.public.sharing.config.tmpl.html')
        .default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.flow.model.owner/runner.library.public.form.config.tmpl.html',
      require('./runner.library.flow.model.owner/runner.library.public.form.config.tmpl.html')
        .default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.tabs.component.tmpl.html',
      require('./runner.library.tabs.component.tmpl.html').default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.procedures/runner.library.procedures.copy.dialog.tmpl.html',
      require('./runner.library.procedures/runner.library.procedures.copy.dialog.tmpl.html')
        .default
    );

    $templateCache.put(
      'Client/runner.library/runner.library.procedures/runner.library.procedures.sharing.dialog.tmpl.html',
      require('./runner.library.procedures/runner.library.procedures.sharing.dialog.tmpl.html')
        .default
    );
  }
]);
